/**
 * Brand paw-print mark — a single pad + 4 toes. Purely decorative
 * (`aria-hidden`); color comes from `currentColor` so callers control it via
 * a wrapping `color` (e.g. `--bsa-canopy-500`). `flip` mirrors the footfall
 * tilt so alternating paws in a trail read as left/right steps (it never
 * mirrors the glyph itself). `direction` sets which way the paw faces —
 * `"up"` (native orientation, toes at top) or `"right"` (toes leading right,
 * for a trail that reads as walking left-to-right).
 */
export function PawIcon({
  flip = false,
  direction = "up",
  className,
}: {
  flip?: boolean;
  direction?: "up" | "right";
  className?: string;
}) {
  const heading = direction === "right" ? 90 : 0;
  return (
    <svg
      viewBox="0 0 26 28"
      fill="currentColor"
      aria-hidden="true"
      className={className}
      style={{
        // translateY first so the footfall offset stays in the screen
        // frame — applying it after the heading rotation would turn the
        // vertical zig-zag into uneven horizontal spacing instead.
        transform: `translateY(${flip ? 7 : -7}px) rotate(${(flip ? 9 : -9) + heading}deg)`,
      }}
    >
      {/* Pad */}
      <ellipse cx="13" cy="20.5" rx="7.6" ry="6.4" />
      {/* Toes */}
      <ellipse cx="4.6" cy="11.5" rx="2.5" ry="3.5" />
      <ellipse cx="10" cy="7" rx="2.5" ry="3.7" />
      <ellipse cx="16" cy="7" rx="2.5" ry="3.7" />
      <ellipse cx="21.4" cy="11.5" rx="2.5" ry="3.5" />
    </svg>
  );
}
